import { defineStyleConfig } from '@chakra-ui/react';

export default defineStyleConfig({
  baseStyle: {},
  defaultProps: {
    colorScheme: 'blue',
  },
  variants: {},
});
